import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 
import Box from '@mui/material/Box';
import DataBox from '../../../general/data/DataBox';
import InfoRow from '../../../general/inputs/InfoRow';
import Button from '../../../general/inputs/Button';
import { cancelSubscription } from '../../../../routes/doctor/billing';
import { setIsRefreshSubscription } from '../../../../redux/features/doctor/billing/billing';
import { setNotificationMessage } from '../../../../redux/features/general/notification';
import { setIsCancelSubscriptionPopupOpened } from '../../../../redux/features/general/navigation';

interface Props { 

}; 

const CancelSubscription: React.FC<Props> = ({ }) => {
    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 
    const subscription = useAppSelector(state => state.billing.subscription); 

    const handleCancelation = async () => { 
        dispatch(setIsCancelSubscriptionPopupOpened(true)); 
    }; 

    return (
        <>
            {(subscription && (subscription?.status !== 'canceled')) && 
                <Box sx={{ width: '100%', maxWidth: '600px' }}>
                    <DataBox
                        title={String(t('endSubscription'))}
                    >
                        <InfoRow 
                            title='cancel'
                            titleStyle={{ marginLeft: 0 }}
                            description={
                                <Button 
                                    title={String(t('endSubscription'))}
                                    triggerFunction={handleCancelation}   
                                    extraStyle={{ 
                                        backgroundColor: 'rgb(150, 150, 150)',
                                        '&:hover': { backgroundColor: colors?.red }
                                    }}
                                />
                            }
                            isDisabled
                        />
                    </DataBox>
                </Box>
            }  
        </>
    );
};

export default CancelSubscription;